/**
 * @generated SignedSource<<bf6edb7d9803cb04b532e2297dbcf3f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FrontendEventTriggeredInput = {
  sourceApp: string;
  type: string;
  value: string;
};
export type useFrontendEventTrackerMutation$variables = {
  input: FrontendEventTriggeredInput;
};
export type useFrontendEventTrackerMutation$data = {
  readonly frontendEventTriggered: string | null;
};
export type useFrontendEventTrackerMutation = {
  variables: useFrontendEventTrackerMutation$variables;
  response: useFrontendEventTrackerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "frontendEventTriggered",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFrontendEventTrackerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFrontendEventTrackerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8400355402e8b8ba765383a7ae59798a",
    "id": null,
    "metadata": {},
    "name": "useFrontendEventTrackerMutation",
    "operationKind": "mutation",
    "text": "mutation useFrontendEventTrackerMutation(\n  $input: FrontendEventTriggeredInput!\n) {\n  frontendEventTriggered(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "7ef56cabf4633b6858bfd4833dcc241b";

export default node;
